module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="c-filter-content c-form">\r\n    <div class="container-fluid">\r\n        <fieldset class="cw-fieldset">\r\n            <div class="row filter-simple col">\r\n                <div class="filter-simple-fields '+
((__t=(columnsFilter))==null?'':__t)+
'"></div>\r\n                <div class="c-button-filter '+
((__t=(columnsButtons))==null?'':__t)+
'">\r\n                    <span class="c-button-filter__more-filter" tabindex="0">'+
((__t=(i18n.t("common:morefilters")))==null?'':__t)+
'</span>\r\n                    <div class="d-flex filterButtonsContainer" '+
((__t=( (hideMainButtons ? "" : "style='display:block'") ))==null?'':__t)+
'>\r\n                        <button type="button" class="search btn btn-primary-bis btn-withIcon" title="'+
((__t=(i18n.t("common:search")))==null?'':__t)+
'" value="search">'+
((__t=(i18n.t("common:apply")))==null?'':__t)+
''+
((__t=(icon.search))==null?'':__t)+
'</button>\r\n                        <button type="button" class="clear btn btn-secondary-bis btn-onlyIcon" title="'+
((__t=(i18n.t("common:clear")))==null?'':__t)+
'" value="clear">'+
((__t=(icon.clear))==null?'':__t)+
'</button>\r\n                    </div>\r\n                </div>\r\n            </div>\r\n            <div class="filter-more">\r\n                <div class="filter-more-fields"></div>\r\n            </div>\r\n            <div class="filter-bottom form-row">\r\n                <div class="form-group customFilterButtonsContainer col d-flex flex-row" />\r\n            </div>\r\n        </fieldset>\r\n    </div>\r\n</div>';
}
return __p;
};
